import { render, staticRenderFns } from "./ObjetivosEspecialidad.vue?vue&type=template&id=46ed500e"
import script from "./ObjetivosEspecialidad.vue?vue&type=script&lang=js"
export * from "./ObjetivosEspecialidad.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports